import { createLiveStore } from "../lib/live-store";
import type { Asset } from "../types/api";

interface AssetDetailData {
  asset: Asset | null;
}

interface AssetDetailExtra {
  assetId: number | undefined;
  setAssetId: (id: number | undefined) => void;
}

export const useAssetDetailStore = createLiveStore<AssetDetailData, AssetDetailExtra>({
  topic: (s) => (s.assetId ? `assets.item.${s.assetId}` : null),
  onSnapshot: (data) => ({ asset: data as Asset }),
  onEvent: (event, state) => {
    if (typeof event === "object" && event && "action" in event) {
      const evt = event as { action: string; data?: Asset };
      if (evt.action === "deleted") return { asset: null };
      if (evt.data) return { asset: evt.data };
    }
    return null;
  },
  state: (set) => ({
    asset: null,
    assetId: undefined,
    setAssetId: (id: number | undefined) => set({ assetId: id, asset: null, _loading: true } as any),
  }),
});
